/// <amd-module name="SuiteCommerce.Blog.LatestPosts.Indicator.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.LatestPosts.Indicator.Model", ["require", "exports", "Backbone", "sc_blog_latest_posts_indicator.tpl"], function (require, exports, Backbone_1, latestPostsIndicatorTemplate) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var LatestPostsIndicatorView = /** @class */ (function (_super) {
        __extends(LatestPostsIndicatorView, _super);
        function LatestPostsIndicatorView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.template = latestPostsIndicatorTemplate;
            return _this;
        }
        LatestPostsIndicatorView.prototype.getContext = function () {
            return {
                label: this.model.index + 1,
            };
        };
        return LatestPostsIndicatorView;
    }(Backbone_1.View));
    exports.LatestPostsIndicatorView = LatestPostsIndicatorView;
});
